import React from 'react';
import Grid from '@material-ui/core/Grid';

import LoadingPage from '../../../common/components/LoadingPage';
import CourseList from '../../../common/components/CourseList';
import '../../../common/components/CourseDetail/index.css';

import { CourseListGraphQL, GET_ALL_COURSES } from '../../../api/content';
import { useGraphqlQuery } from '../../../hooks/api';

export default function CourseListPage() {
  const { isLoading, data: { courses } = {} } = useGraphqlQuery<{
    courses: CourseListGraphQL[];
  }>(
    { document: GET_ALL_COURSES },
    {
      queryKey: ['course', 'list'],
      errorMessage: "We're having trouble loading Picardy courses right now.",
    },
  );

  if (isLoading || !courses) return <LoadingPage />;

  return (
    <Grid item xl={8} lg={9} md={10} xs={12}>
      <CourseList title="Explore" courses={courses} />
    </Grid>
  );
}
